import type { SnackbarType } from './types';

const toastTypeGuard = (type: string | undefined): type is SnackbarType => {
  if (type && ['error', 'info', 'success'].includes(type)) return true;
  return false;
};

export const getSafeToastType = (type: string | undefined): SnackbarType => {
  if (type && toastTypeGuard(type)) return type;
  return 'info';
};
